<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 19:00:33
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-11-15 14:46:44
-->
<template>
  <div class="index-news wh100">
    <div class="ui-index-title m-t-10 m-b-10">{{ $t('frontPage.news.title') }}</div>
    <div class="flex index-news-main">
      <div id="indexNews" class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in $t('frontPage.news.dynamicData')" :key="`dsf_${index}`" >
            <a :class="['flex_1 index-news-item']" :href="item.url" target="_blank">
              <div class="index-news-item-img">
                <van-image class="wh100" :src="item.poster" fit="contain"/>
              </div>
              <div class="p-30">
                <div class="clearfix">
                  <div class="index-news-item-num time fl">{{item.time}}</div>
                  <div class="index-news-item-title ellipsis fl" v-html="item.title"></div>
                </div>
                <div class="clearfix p-t-8">
                  <div class="index-news-item-num fl">{{item.year}}</div>
                  <div class="index-news-item-des ellipsis fl" v-html="item.des"></div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () {
    this.mySwiper = new this.$Swiper('#indexNews', {
      autoplay: true
    })
  }
}
</script>

<style lang="less" scoped>
// @import '@/styles/globalVars.less';
.m .index-news {
  color: #333333;
  padding-top: 30px;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  .index-news-main {
    font-size: 24px;
    position: relative;
    padding: 30px 0;
    .swiper {
      width: 100vw;
    }
    .index-news-item {
      line-height: 34px;
      color: #333333;
      .index-news-item-img {
        width: 100vw;
        height: 66.7vw; /*no*/
        overflow: hidden;
        margin-bottom: 16px;
        background: #ffffff;
        .van-image__img {
          display: block;
        }
      }
      .index-news-item-num {
        position: absolute;
        color: #000000;
        &.time {
          font-size: 30px;
          color: #00A0E9;
        }
      }
      .index-news-item-title {
        font-weight: 600;
        padding-left: 100px;
        width: 100%;
      }
      .index-news-item-des {
        padding-left: 100px;
        width: 100%;
        @extend textoverflow(2);
      }
    }
  }
}
</style>
